import { axiosInstance } from './base'

export function fetchRfps (query) {
  let path = 'rfps/'
  if (query) path = 'rfps/' + query
  return axiosInstance.get(path)
}

export function fetchRfp (id) {
  return axiosInstance.get(`rfps/${id}`)
}

export function rfpFreeTrial () {
  return axiosInstance.get('rfps/free-trial')
}

export function addRfp (data) {
  return axiosInstance.post('rfps/', data)
}

export function rfpExport (rfpId) {
  return axiosInstance.get(`rfps-export/${rfpId}`)
}

export function approveRfp (rfpId) {
  return axiosInstance.put(`approve-rfp/${rfpId}`)
}

export function declineRfp (rfpId) {
  return axiosInstance.put(`decline-rfp/${rfpId}`)
}
